import { createContext, useContext, useEffect, useState } from "react";
import { setAccessToken, removeAccessToken, getAccessToken, getUserStorage, setUserStorage, removeUserStorage } from "../services/authService";
import { useNavigate } from "react-router-dom";
import { setAuthHelper } from "../services/authHelper";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = getUserStorage();
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const navigate = useNavigate(); // 🔥 Usar const en lugar de let

  const clearSession = () => {
    removeAccessToken();  // 🔥 Elimina el token de sessionStorage
    setUser(null);        // 🔥 Borra datos del usuario
    // navigate("/login", { replace: true });  // 🔥 Redirección limpia con React Router
  };

  // useEffect(() => {
  //   console.log("user before clear", user)
  //   if (!user) return; // 🔥 Evita ejecutar si no hay usuario
  //   clearSession();
  //   console.log("clearing Session")
  // }, [user]);

  const login = (userData, token) => {
    setUser(userData);
    setUserStorage(userData);
    setAccessToken(token);
    navigate('/profile');
  };

  const logout = (redirect = false) => {
    setUser(null);
    removeAccessToken(); // ✅ Usar removeAccessToken en lugar de setAccessToken(null)
    removeUserStorage();
    if (redirect) {
      navigate("/login"); // Redirige al login
    }
  };

  const updateUsername = (newValue) => {
    setUser(prevState => ({...prevState, username: newValue}));
    const userFromStorage = JSON.parse(getUserStorage());
    userFromStorage.username = newValue;
    setUserStorage(userFromStorage);
  }

  useEffect(() => {
    setAuthHelper(() => logout(true)); // 🔥 Registrar logout globalmente
    const token = getAccessToken();
    if (token) {
      setAccessToken(token); // ⚡️ Restaurar el token en el estado
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, clearSession, updateUsername }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
